import * as React from "react"

function SvgFeatherPlus(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather-plus_svg__feather feather-plus_svg__feather-plus"
      {...props}
    >
      <path d="M12 5v14M5 12h14" />
    </svg>
  )
}

export default SvgFeatherPlus
